import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2a5e8ab0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.4@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports